"use client";
import React from "react";
import ModuleSidebar from "./module";
import PopoverSidebar from "./popover";
import ClassicSidebar from "./classic";
import MobileSidebar from "./mobile-sidebar";
import { useSidebar } from "../../../store";
import { useMediaQuery } from "../../../hooks";

const Sidebar = () => {
  const { sidebarType, collapsed } = useSidebar();

  const isDesktop = useMediaQuery("(min-width: 1280px)");

  let selectedSidebar = null;

  if (!isDesktop && (sidebarType === "popover" || sidebarType === "classic")) {
    selectedSidebar = <MobileSidebar />;
  } else {
    const sidebarComponents = {
      module: <ModuleSidebar collapsed={collapsed} />,
      popover: <PopoverSidebar collapsed={collapsed} />,
      classic: <ClassicSidebar />,
    };

    selectedSidebar = sidebarComponents[sidebarType] || <ModuleSidebar />;
  }

  return <div>{selectedSidebar}</div>;
};

export default Sidebar;
